import React from 'react';
interface SectionDividerProps {
  topColor: string;
  bottomColor: string;
  flip?: boolean;
}
export function SectionDivider({
  topColor,
  bottomColor,
  flip = false
}: SectionDividerProps) {
  return <div className={`w-full overflow-hidden leading-none ${topColor}`} data-id="element-318">
      <svg viewBox="0 0 1440 120" preserveAspectRatio="none" className={`w-full h-12 md:h-24 lg:h-32 ${flip ? 'rotate-180' : ''}`} style={{
      display: 'block'
    }} data-id="element-319">
        <path d="M0,60 C320,120 420,0 740,60 C1060,120 1160,0 1440,60 L1440,120 L0,120 Z" className={bottomColor} fill="currentColor" data-id="element-320" />
      </svg>
    </div>;
}